import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TFMService } from 'app/mock-api/tfm.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';


@Component({
  selector: 'app-service-item-remove',
  standalone: true,
  imports: [],
  templateUrl: './service-item-remove.component.html',
  styleUrl: './service-item-remove.component.scss'
})
export class ServiceItemRemoveComponent {
  public view : any = {
      // service: {
      //   supplier: '',
      //   service: '',
      //   cost: null,
      //   exchangeRateCurrent: null,
      //   price: null,
      //   start: null,
      //   end: null,
      //   adultCount: null,
      //   teenCount: null,
      //   childCount: null,
      //   infantCount: null,
      //   internalNote: '',
      //   chk1: false
      // }
    };
  
    constructor(public tfmService: TFMService,public dialogRef: MatDialogRef<ServiceItemRemoveComponent>, @Inject(MAT_DIALOG_DATA) public data:any,private dialog: MatDialog){
      this.view.service = this.data
    }

  removeServiceItem() {
    if (this.view.service) {
      //console.log("Remove service item", this.view.service);

      this.tfmService.filterAndSend(this.view.service._links, "delete", this.view.service).subscribe(res => {
        console.log("Service removed");
        this.dialogRef.close();
        this.openConfirmationModal({
          title: 'Service is Removed',
          message: 'The service has been removed successfully',
          showClose: true,
          showViewQuotes: false,
          showNewQuote: false
        });

        // this.itinOptionsLoad();
      });
    }
  }
  close(): void {
    this.dialogRef.close();
  }
  openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean;}) {
    this.dialog.open(ConfirmationDialogComponent, {
      data: config
    });
  }
  

}
